import { createFileRoute } from '@tanstack/react-router';
import { AISystemUsagePage } from '@/pages/admin/ai-usage';
import { aiUsageSearchSchema } from '@/routes/-shared/aiUsageSearchSchema';

export const Route = createFileRoute('/admin/_layout/ai-usage/')({
  component: AISystemUsagePage,
  validateSearch: aiUsageSearchSchema,
});
